<!--Entity visualizer / visual controller -->
<div mat-dialog-title>
	<fa-icon icon="times" (click)="onCancelClick()" class="fdm-icon float-right" style="cursor:pointer;color:#555;margin-top:-20px;margin-right:-14px;"></fa-icon>
	{{ data.title | translate }}
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
<div mat-dialog-content>
    <div class="fdm-big-choice-box fdm-buttons" style="margin-top:15px;">

        <div class="fdm-buttons" cdkDropList (cdkDropListDropped)="drop($event)">

            <div *ngFor="let rule of rules;let idx = index" cdkDragLockAxis="y" cdkDrag class="section-rule clearfix">

                <!-- <textarea style="width:100%;height:100px;font-size:9px;">{{ rule | json }}</textarea> -->
                
                <div class="section-header clearfix" cdkDragHandle>
                    <fa-icon icon="times-circle" class="fdm-linked float-right" style="font-size:25px;" (click)="removeRule(rule)"></fa-icon>
                
                    <div class="section-options">
                        <span class="float-left fdm-linked" style="font-size:16px;">
                            <fa-icon icon="grip-lines"></fa-icon>
                            {{ 'PLUGINS.ENTITY_VISUALIZER.RULE_NO' | translate }}{{ idx + 1}}
                        </span>
                        <mat-checkbox *ngFor="let c of controllers" class="float-left" [checked]="rule[c] ? true : false" (change)="setController(c,rule)" style="margin-left:15px;">
                            {{ c }}
                        </mat-checkbox> 
                    </div>
                </div>

                <div class="section-content container-fluid row">
                    <ng-container *ngFor="let c of controllers">
                        <ng-container *ngIf="rule[c]">


                            <div class="col-5 section-controller" *ngIf="c == 'condition'">
                                <table>
                                    <tr>
                                        <th>{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_WHEN' | translate }}</th>
                                        <th>{{ 'PLUGINS.ENTITY_VISUALIZER.IS' | translate }}</th>
                                        <th>{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_THIS' | translate }}</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <select [(ngModel)]="rule[c].property">
                                                <option *ngFor="let aa of data.properties | keyvalue" [value]="aa.value" >
                                                    {{aa.value}}
                                                </option>
                                            </select>
                                        </td>
                                        <td class="small">
                                            <select [(ngModel)]="rule[c].testForNegative">
                                                <option [value]="-1">{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_NOT_LIKE' | translate }}</option>
                                                <option [value]="1">{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_LIKE' | translate }}</option>
                                                <option [value]="-2">{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_UNDER' | translate }}</option>
                                                <option [value]="2">{{ 'PLUGINS.ENTITY_VISUALIZER.CONDITION_OVER' | translate }}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="rule[c].value" />
                                        </td>
                                    </tr>
                                </table>
                            </div>


                            <div class="col-3 section-controller" *ngIf="c == 'range'">
                                {{ 'PLUGINS.ENTITY_VISUALIZER.PROPERTY' | translate }}
                                <select [(ngModel)]="rule[c].property">
                                    <option *ngFor="let aa of data.properties | keyvalue" [value]="aa.value" >
                                        {{aa.value}}
                                    </option>
                                </select>
                                <hr>
                                <ng-container *ngFor="let r of rule[c].ranges; let idx = index;">
                                    <div>
                                        <span *ngIf="idx !== rule[c].ranges.length-1" class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="position:absolute;margin-top:22px;">{{ idx+1 }}</span>
                                        <input style="margin-left:45px;width:130px;" type="text" [value]="r" (change)="updateRuleValue(rule[c].ranges,idx,$event)">
                                        <fa-icon *ngIf="rule[c].ranges.length > 2 && idx > 0" matTooltip="Delete" class="fdm-linked" icon="minus" (click)="deleteRange(idx,rule[c].ranges)"></fa-icon>
                                    </div>
                                    <fa-icon *ngIf="idx < rule[c].ranges.length" matTooltip="Add" icon="plus" class="fdm-linked" style="margin-left:95px;" (click)="addRange(idx,rule[c].ranges)"></fa-icon>
                                </ng-container>
                            </div>


                            <div class="col-2 section-controller" *ngIf="c == 'color'">
                                <div class="fdm-choice-box">
                                    {{ 'PLUGINS.ENTITY_VISUALIZER.COLOR' | translate }}

                                    <table *ngIf="rule['range']" style="width:100%;">
                                        <tr *ngFor="let r of rule['range'].ranges; let idx = index;">
                                            <ng-container *ngIf="idx !== rule['range'].ranges.length-1">
                                                <td style="width:50px;">
                                                    <span class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="margin-right:11px;margin-top:-2px;">{{ idx+1 }}</span>
                                                </td>
                                                <td>
                                                    <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="z-index:999;"
                                                        [(colorPicker)]="rule[c].rangeValue[idx]" 
                                                        [style.background]="rule[c].rangeValue[idx]" 
                                                        cpOutputFormat="rgba"
                                                        cpAlphaChannel="enabled"
                                                        cpPosition="bottom"
                                                        cpPositionOffset="50%"
                                                        [cpPositionRelativeToArrow]="true"
                                                    ><fa-icon icon="chevron-down"></fa-icon>
                                                    </div>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </table>
                                    <ng-container *ngIf="!rule['range']">
                                        <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="z-index:999;float:right;"
                                            [(colorPicker)]="rule[c].value" 
                                            [style.background]="rule[c].value" 
                                            cpOutputFormat="rgba"
                                            cpAlphaChannel="enabled"
                                            cpPosition="bottom"
                                            cpPositionOffset="50%"
                                            [cpPositionRelativeToArrow]="true"
                                        ><fa-icon icon="chevron-down"></fa-icon>
                                        </div>
                                    </ng-container>
                                    
                                    <span class="clearfix"></span>
                                </div>
                            </div>


                            <div class="col-2 section-controller" *ngIf="c == 'outline'">
                                <div class="fdm-choice-box">
                                    {{ 'PLUGINS.ENTITY_VISUALIZER.COLOR_OUTLINE' | translate }}
                                    
                                    <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="z-index:999;float:right;"
                                        [(colorPicker)]="rule[c].value" 
                                        [style.background]="rule[c].value" 
                                        cpOutputFormat="rgba"
                                        cpAlphaChannel="enabled"
                                        cpPosition="bottom"
                                        cpPositionOffset="50%"
                                        [cpPositionRelativeToArrow]="true"
                                    ><fa-icon icon="chevron-down"></fa-icon>
                                    </div>
                                    <span class="clearfix"></span>
                                </div>
                                <div style="margin-bottom:10px;width:100%;">
                                    <mat-slider *ngIf="rule[c]['size']" color="primary" class="fdm-layer-slider" style="width:100px;" min="0" max="10" step="1" [(ngModel)]="rule[c]['size']" (input)="rule[c]['size'] = $event.value"></mat-slider>
                                    {{ 'PLUGINS.ENTITY_VISUALIZER.SIZE' | translate }} {{ rule[c]['size'] }}
                                </div>
                            </div>


                            <div class="col-4 section-controller" *ngIf="c == 'label'">
    
                                <table *ngIf="rule['range']" style="width:100%;">
                                    <tr *ngFor="let r of rule['range'].ranges; let idx = index;">
                                        <ng-container *ngIf="idx !== rule['range'].ranges.length-1">
                                            <td style="width:50px;">
                                                <span class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="margin-right:11px;margin-top:-2px;">{{ idx+1 }}</span>
                                            </td>
                                            <td>
                                                
                                                <mat-radio-group class="this-radio-group" [(ngModel)]="rule[c].rangeProperty[idx]">
                                                    <mat-radio-button class="this-radio-button" [value]="false">{{ 'PLUGINS.ENTITY_VISUALIZER.TEXT' | translate }}</mat-radio-button>
                                                    <mat-radio-button class="this-radio-button" [value]="true">{{ 'PLUGINS.ENTITY_VISUALIZER.PROPERTY_VALUE' | translate }}</mat-radio-button>
                                                </mat-radio-group>
                    
                                                <div *ngIf="rule[c].rangeProperty[idx]">
                                                    <mat-form-field class="mt-2">
                                                        <mat-select [(ngModel)]="rule[c].rangeValue[idx]" style="font-size: 14px;">
                                                          <mat-option *ngFor="let aa of data.properties | keyvalue" [value]="aa.value" >
                                                            {{aa.value}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                                <div *ngIf="!rule[c].rangeProperty[idx]" class="fdm-expand-on-focus-container">
                                                    <input type="text" class="fdm-expand-on-focus" [(ngModel)]="rule[c].rangeValue[idx]" />
                                                    <input type="text" class="fdm-expand-on-focus-hidden" />
                                                </div>

                                            </td>
                                            <td>
                                                <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="z-index:999;float:right;"
                                                    [(colorPicker)]="rule[c].rangeTextcolor[idx]" 
                                                    [style.background]="rule[c].rangeTextcolor[idx]" 
                                                    cpOutputFormat="rgba"
                                                    cpAlphaChannel="enabled"
                                                    cpPosition="bottom"
                                                    cpPositionOffset="50%"
                                                    [cpPositionRelativeToArrow]="true"
                                                ><fa-icon icon="chevron-down"></fa-icon>
                                                </div>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </table>
                                <ng-container *ngIf="!rule['range']">
                                    <mat-radio-group class="this-radio-group" [(ngModel)]="rule[c].property">
                                        <mat-radio-button class="this-radio-button" [value]="false">{{ 'PLUGINS.ENTITY_VISUALIZER.TEXT' | translate }}</mat-radio-button>
                                        <mat-radio-button class="this-radio-button" [value]="true">{{ 'PLUGINS.ENTITY_VISUALIZER.PROPERTY_VALUE' | translate }}</mat-radio-button>
                                    </mat-radio-group>
        
                                    <div *ngIf="rule[c].property">
                                        <mat-form-field class="mt-2">
                                            <mat-select [(ngModel)]="rule[c].value" style="font-size: 14px;">
                                              <mat-option *ngFor="let aa of data.properties | keyvalue" [value]="aa.value" >
                                                {{aa.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div *ngIf="!rule[c].property">
                                        <input matInput type="text" style="font-size:10px;width:100%;" [(ngModel)]="rule[c].value" />
                                    </div>
                                    <div class="fdm-circle-choice fdm-annotation-color-white fdm-annotation-background-color-orange" style="z-index:999;float:right;"
                                                    [(colorPicker)]="rule[c].textcolor" 
                                                    [style.background]="rule[c].textcolor" 
                                                    cpOutputFormat="rgba"
                                                    cpAlphaChannel="enabled"
                                                    cpPosition="bottom"
                                                    cpPositionOffset="50%"
                                                    [cpPositionRelativeToArrow]="true"
                                                ><fa-icon icon="chevron-down"></fa-icon>
                                                </div>
                                </ng-container>
                                
                            </div>


                            <div class="col-2 section-controller" *ngIf="c == 'icon'">
    
                                <div style="margin-bottom:10px;width:100%;">
                                    <mat-slider *ngIf="rule[c]['size']" color="primary" class="fdm-layer-slider" style="width:180px;" min="5" max="60" step="1" [(ngModel)]="rule[c]['size']" (input)="rule[c]['size'] = $event.value"></mat-slider>
                                    {{ 'PLUGINS.ENTITY_VISUALIZER.SIZE' | translate }} {{ rule[c]['size'] }}
                                </div>

                                <span *ngFor="let cur of [
                                    'map-pin','map-marker','map-marker-alt','flag','bell','thumbtack',
                                    'biohazard','bolt','bookmark','info-circle','exclamation-triangle', 'question-circle',
                                    'lock','lock-open','box-open',
                                    'briefcase-medical','bullhorn','fire','first-aid',
                                    'grin','meh','frown','skull','star',
                                    'car','car-crash','taxi','motorcycle','bus','truck','tractor','train','subway','ship','helicopter','plane','rocket','satellite','satellite-dish',
                                    'building','hotel','dumpster',
                                    'camera','clipboard','clock','comment','door-open','drafting-compass','ruler','screwdriver'
                                ]"  class="section-icon" [class.fdm-selected]="rule[c].value == cur"
                                    (click)="rule[c].value = cur">
                                    <fa-icon [icon]="cur"></fa-icon>
                                </span>
    
                            </div>


                        </ng-container>
                        
                    </ng-container>
                </div>
                
            </div>

            <div translate class="alert alert-default mt-2 mb-2" *ngIf="rules && rules.length == 0">
                PLUGINS.ENTITY_VISUALIZER.NO_RULES
            </div>
            
        </div>

        <button class="fdm-button" mat-flat-button color="primary" style="color:#fff;height:25px;" (click)="addRule()"> 
            <fa-icon icon="plus-circle"></fa-icon> &nbsp;{{ 'PLUGINS.ENTITY_VISUALIZER.ADD_RULE' | translate }}
        </button>

        <!-- <textarea style="width:100%;height:150px;font-size:8px;">{{ rules | json }}</textarea> -->

    </div>

    <!-- <div class="fdm-big-choice-box" style="margin-top:15px;">
        <label>Specific items</label>

        <div class="section fdm-buttons">
            <label>
                <mat-checkbox class="float-left" 
                (change)="enableDisableVisualController()" style="margin-right:6px;"></mat-checkbox> color
                
                <fa-icon class="fdm-help-tiny-icon float-right" icon="question-circle" (click)="helpToggle('helpCoordinates',CAMERAS)"></fa-icon>
            </label>
        </div>

        <div *ngFor="let p of data.properties | keyvalue">
            [{{ p.value }}]
        </div>

    </div> -->

    
</div>
<div mat-dialog-actions class="align-content-right">
    <button *ngIf="data.negBtn" color="primary" mat-button (click)="onCancelClick()"> {{ 'GENERIC.CANCEL' | translate }}</button>
    <button color="primary" mat-button (click)="onSaveClick()" >{{ 'GENERIC.SAVE' | translate }}</button>
</div>
